import { render, staticRenderFns } from "./NxSigningModalFailure.vue?vue&type=template&id=b4ed944e&scoped=true&"
import script from "./NxSigningModalFailure.vue?vue&type=script&lang=js&"
export * from "./NxSigningModalFailure.vue?vue&type=script&lang=js&"
import style0 from "./NxSigningModalFailure.vue?vue&type=style&index=0&id=b4ed944e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ed944e",
  null
  
)

/* custom blocks */
import block0 from "@/locales/responseMsg.locale?vue&type=custom&index=0&blockType=i18n&issuerPath=E%3A%5Capp%5CJenkins%5Cworkspace%5CAll_IaaS_Farm%5C0%20nextoreV3bdclient_build%5Csrc%5Csrc%5Ccomponents%5Cnx-signing-modal%5CNxSigningModalFailure.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports